export type TColumns = {
    symbolik: string;
    adresse: string;
    type: string;
    funktionstext: string;
}

export type TTable = {
    group: string;
    columns: TColumns
}

export type TStatusColumns = {
    change: boolean;
    adjusment: boolean;
    new: boolean;
    deleted: boolean;
}

export type TStatus = {
    group: string;
    columns: TStatusColumns
}

export type TRowData = {
    tableOne: TTable;
    Status?: TStatus;
    tableTwo?: TTable
};
  

export const rows: TRowData[] = [
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "_070TRR001_X4:4",
                adresse: "I7701.0",
                type: "BOOL",
                funktionstext: "Sicherheitsschalter -BGS1V",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: true,
                deleted: false
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        },
        
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: false,
                deleted: true
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "_002BR_010_FN2:12",
                adresse: "I10.0",
                type: "BOOL",
                funktionstext: "Not-Halt Bedienrechner",
            }
        },
        
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: false,
                deleted: true
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "_002BR_010_FN1:22",
                adresse: "I10.6",
                type: "BOOL",
                funktionstext: "VI-Schalter Kanal 1",
            }
        },
        
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: false,
                deleted: true
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "_002BR_010_FN1:14",
                adresse: "I10.7",
                type: "BOOL",
                funktionstext: "VI-Schalter Kanal 2",
            }
        },
        
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "_050GST001_QM1MM1BG21:4",
                adresse: "I3306.0",
                type: "BOOL",
                funktionstext: "Spanner 11 geöffnet GS",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: false,
                adjusment: false,
                new: false,
                deleted: false
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "_050GST001_QM1MM1BG21:4",
                adresse: "I3306.0",
                type: "BOOL",
                funktionstext: "Spanner 11 geöffnet GS",
            }
        },
        
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "_050GST001_QM1MM1BG11:2",
                adresse: "I3306.1",
                type: "BOOL",
                funktionstext: "Spanner 11 geschlossen AS",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: false,
                adjusment: false,
                new: false,
                deleted: false
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "_050GST001_QM1MM1BG11:2",
                adresse: "I3306.1",
                type: "BOOL",
                funktionstext: "Spanner 11 geschlossen AS",
            }
        },
        
    },

    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "_050GST001_QM4MM2BG11:2",
                adresse: "I3308.5",
                type: "BOOL",
                funktionstext: "Spanner 42 geschlossen AS",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: false,
                adjusment: false,
                new: false,
                deleted: false
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "_050GST001_QM4MM2BG11:2",
                adresse: "I3308.5",
                type: "BOOL",
                funktionstext: "Spanner 42 geschlossen AS",
            }
        },
        
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "_050GST001_QM4MM3BG21:4",
                adresse: "I3308.6",
                type: "BOOL",
                funktionstext: "Spanner 43 geöffnet GS",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: true,
                new: false,
                deleted: false
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "_050GST001_QM5MM1BG21:4",
                adresse: "I3308.6",
                type: "BOOL",
                funktionstext: "Spanner 51 geöffnet GS",
            }
        },
        
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "_050GST001_QM4MM3BG11:2",
                adresse: "I3308.7",
                type: "BOOL",
                funktionstext: "Spanner 43 geschlossen AS",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: true,
                new: false,
                deleted: false
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "_050GST001_QM5MM1BG11:2",
                adresse: "I3308.7",
                type: "BOOL",
                funktionstext: "Spanner 51 geschlossen AS",
            }
        },
        
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "_050GST001_BZ1.1:4",
                adresse: "I3310.2",
                type: "BOOL",
                funktionstext: "Bauteilkontrolle 1.1",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: true,
                new: false,
                deleted: false
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "_050GST001_QM6MM5BG21:4",
                adresse: "I3310.2",
                type: "BOOL",
                funktionstext: "Spanner 65 geöffnet GS",
            }
        },
        
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "_050GST001_BZ1.2:4",
                adresse: "I3310.3",
                type: "BOOL",
                funktionstext: "Bauteilkontrolle 1.2",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: true,
                new: false,
                deleted: false
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "_050GST001_QM6MM5BG11:2",
                adresse: "I3310.3",
                type: "BOOL",
                funktionstext: "Spanner 65 geschlossen AS",
            }
        }, 
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "_070TRR001_X4:4",
                adresse: "I7701.0",
                type: "BOOL",
                funktionstext: "Sicherheitsschalter -BGS1V",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: true,
                deleted: false
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        }, 
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "_070TRR001_X4:2",
                adresse: "I7701.2",
                type: "BOOL",
                funktionstext: "Sicherheitsschalter -BGS1V",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: true,
                deleted: false
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        }, 
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "_050GST001_KF070.5:Z0",
                adresse: "Q3300.0",
                type: "BOOL",
                funktionstext: "Sichere Zone 0",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: true,
                deleted: false
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        }, 
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "_050GST001_KF070.5:Z1",
                adresse: "Q3300.1",
                type: "BOOL",
                funktionstext: "Sichere Zone 1",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: true,
                deleted: false
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        }, 
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "_050GST001_KF070.5:Z2",
                adresse: "Q3300.2",
                type: "BOOL",
                funktionstext: "Sichere Zone 2",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: true,
                deleted: false
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        }, 
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "_050GST001_QM101MB111",
                adresse: "Q3306.0",
                type: "BOOL",
                funktionstext: "Steuerluftventil ein",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: true,
                deleted: false
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        }, 
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "_050GST001_QM101MB112",
                adresse: "Q3306.2",
                type: "BOOL",
                funktionstext: "Steuerluftventil ein",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: true,
                deleted: false
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        }, 
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "_050GST001_QM1MB11",
                adresse: "Q3306.4",
                type: "BOOL",
                funktionstext: "Spannergruppe 10 schliessen AS",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: true,
                deleted: false
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        }, 
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: false,
                deleted: true
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "_Q4323.0",
                adresse: "Q4323.0",
                type: "BOOL",
                funktionstext: "",
            }
        }, 
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: false,
                deleted: true
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "_Q4323.1",
                adresse: "Q4323.1",
                type: "BOOL",
                funktionstext: "",
            }
        }, 
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: false,
                deleted: true
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "_Q4323.2",
                adresse: "Q4323.2",
                type: "BOOL",
                funktionstext: "",
            }
        }, 
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: false,
                deleted: true
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "_Q4323.3",
                adresse: "Q4323.3",
                type: "BOOL",
                funktionstext: "",
            }
        }, 
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: false,
                deleted: true
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "_Q4323.4",
                adresse: "Q4323.4",
                type: "BOOL",
                funktionstext: "",
            }
        }, 
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: false,
                deleted: true
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "_Q4323.5",
                adresse: "Q4323.5",
                type: "BOOL",
                funktionstext: "",
            }
        }, 
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: false,
                deleted: true
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "_Q4323.6",
                adresse: "Q4323.6",
                type: "BOOL",
                funktionstext: "",
            }
        }, 
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: false,
                deleted: true
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "_Q4323.7",
                adresse: "Q4323.7",
                type: "BOOL",
                funktionstext: "",
            }
        }, 
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "_050TSK101_XD13:4",
                adresse: "Q4590.0",
                type: "BOOL",
                funktionstext: "Reduzierte Geschwindigkeit",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: false,
                deleted: true
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        }, 
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "_050TSK101_XD13:4",
                adresse: "Q4590.1",
                type: "BOOL",
                funktionstext: "Reduzierte Geschwindigkeit",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: false,
                deleted: true
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        }, 
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "_050TSK101_XD13:4",
                adresse: "Q4590.2",
                type: "BOOL",
                funktionstext: "Reduzierte Geschwindigkeit",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: true,
                deleted: false
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        }, 
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: true,
                deleted: false
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "_Q5150.0",
                adresse: "Q5150.0",
                type: "BOOL",
                funktionstext: "",
            }
        }, 
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: true,
                deleted: false
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "_050LS_001_PF1:2",
                adresse: "Q5170.1",
                type: "BOOL",
                funktionstext: "Reserve",
            }
        }, 
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: false,
                deleted: true
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "_050LS_001_PF1:3",
                adresse: "Q5170.2",
                type: "BOOL",
                funktionstext: "Reserve",
            }
        }, 
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "_050GST001_QM8MM1BG21:4",
                adresse: "Q5310.5",
                type: "BOOL",
                funktionstext: "Verriegelung 81 geschlossen GS",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: true,
                deleted: false
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        }, 
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "_050GST001_QM8MM1BG22:4",
                adresse: "Q5310.6",
                type: "BOOL",
                funktionstext: "Verriegelung 81 geschlossen GS",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: true,
                deleted: false
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        }, 
    },
    {
        tableOne: {
            group: 'SPS',
            columns: {
                symbolik: "_050GST001_QM28MM1BG21:4",
                adresse: "Q5310.7",
                type: "BOOL",
                funktionstext: "Verriegelung 81 geschlossen GS",
            }
        },
        Status: {
            group: 'Status',
            columns: {
                change: true,
                adjusment: false,
                new: true,
                deleted: false
            }
        },
        tableTwo: {
            group: 'EPlan',
            columns: {
                symbolik: "",
                adresse: "",
                type: "",
                funktionstext: "",
            }
        }, 
    }
];